// extracted by mini-css-extract-plugin
export var aircallIframe = "_cx-3";
export var fabContainer = "_cx-5";
export var fabRinging = "_cx-6";
export var loadingOverlay = "_cx-4";
export var pulse = "_cx-7";
export var widgetContent = "_cx-2";
export var widgetPanel = "_cx-0";
export var widgetPanelExpanded = "_cx-1";